import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="not-found-page">
      <div class="container">
        <div class="not-found-content">
          <div class="error-code">404</div>
          <h1 class="error-title">Page not found</h1>
          <p class="error-description">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div class="error-actions">
            <a routerLink="/" class="btn btn-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              Back to home
            </a>
            <a routerLink="/blog" class="btn btn-outline">Read the blog</a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .not-found-page {
      min-height: 60vh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: var(--space-12) 0;
    }
    .not-found-content {
      text-align: center;
      max-width: 480px;
      margin: 0 auto;
      padding: 0 var(--space-6);
    }
    .error-code {
      font-size: clamp(5rem, 15vw, 9rem);
      font-weight: 800;
      line-height: 1;
      margin-bottom: var(--space-4);
      letter-spacing: -0.05em;
      font-family: 'JetBrains Mono', monospace;
      background: linear-gradient(135deg, var(--accent-primary), var(--accent-glow));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    .error-title {
      font-size: var(--text-2xl);
      margin-bottom: var(--space-3);
    }
    .error-description {
      color: var(--text-muted);
      font-size: var(--text-md);
      margin-bottom: var(--space-6);
    }
    .error-actions {
      display: flex;
      gap: var(--space-2);
      justify-content: center;
      flex-wrap: wrap;
    }
  `]
})
export class NotFoundComponent { }
